import React, { useState } from "react";
import "./AdminDesignerInfo.css";
import { Button, Modal } from "react-bootstrap";

export default function AdminDesignerInfo({designerList, setDesignerList}) {
  // Create a new designer account
  const [fullName, setFullName] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState("show");
  const [designation, setDesignation] = useState("");
  // Delete a designer account by email
  const [ setDeleteEmail] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const [addProfile, setAddProfile] = useState(false);
  const [editProfile, setEditProfile] = useState(false);
  const [deleteProfile, setDeleteProfile] = useState(false);

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const processedCustomerList = designerList.map((item) => {
    return {
      name: item.fullName,
      designation: item.designation,
      phoneNumber: item.phoneNo,
      email: item.email,
      password: item.password,
    };
  });

  processedCustomerList.push(processedCustomerList[0]);

  return (
    <>
      
      <div className="adminDesignerInfo">
        <div className="designerListHeader">
          <form>
            <i className="bi bi-search"></i>
            <input
              type="text"
              placeholder="Search by Name/Designation"
              value={searchTerm}
              onChange={handleSearchInputChange}
            />
          </form>
          <div>
            <button
              className="addDesignerBtn"
              onClick={() => {
                setAddProfile(true);
              }}
            >
              <i
                className="bi bi-plus-lg"
                style={{
                  color: "rgb(39, 50, 106)",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              />
              Add Profile
            </button>
          </div>
        </div>
        {designerList.length > 0 ? (
          <div className="designerList">
            <div style={{ overflowX: "scroll", width: "100%" }}>
              <table>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Designation</th>
                    <th>Phone Number</th>
                    <th>Email ID</th>
                    <th>Password</th>
                    <th>No Of Project</th>
                    <th style={{ width: "100px" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {designerList.map((item, index) => (
                    <tr key={index}>
                      <td> {item.fullName} </td>
                      <td> {item.designation} </td>
                      <td> {item.phoneNo} </td>
                      <td> {item.email} </td>
                      <td> {item.password} </td>
                      <td>{item.noOfProject}</td>
                      <td>
                        <span className="options-icon">
                          <div className="actions">
                            <i
                              onClick={() => {
                                setFullName(item.fullName);
                                setDesignation(item.designation);
                                setPhoneNo(item.phoneNo);
                                setEmail(item.email);
                                setPassword(item.password);
                                setEditProfile(true);
                              }}
                              className="bi bi-pencil-fill"
                              style={{
                                color: "rgb(39, 50, 106)",
                                padding: "12px 12px 12px 0",
                              }}
                            />
                            <i
                              onClick={() => {
                                setDeleteProfile(true);
                                setDeleteEmail(item.email);
                              }}
                              className="bi bi-trash-fill"
                              style={{
                                color: "rgb(255, 0, 0)",
                                padding: "12px",
                              }}
                            />
                          </div>
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div className="noDesigner">
            <img src="./images/Logos/Group.svg" alt="No Designer yet"></img>
            <h2>You don't have any designers right now</h2>
          </div>
        )}
      </div>
      {/* //  )} */}
      <Modal
        show={addProfile || editProfile}
        onHide={() => {
          setAddProfile(false);
          setEditProfile(false);
        }}
        backdrop="static"
        keyboard={false}
        centered
        className="addProfileModal"
      >
        <Modal.Header closeButton>
          <Modal.Title className="title">
            {addProfile ? "Add Profile" : "Edit Profile"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="input-pair">
            <label className="label-name">Name</label>
            <input
              className="simple-inp"
              placeholder="John Doe"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
            />
          </div>
          <div className="input-pair">
            <label className="label-name">Designation</label>
            <input
              className="simple-inp"
              placeholder="John and Company"
              value={designation}
              onChange={(e) => setDesignation(e.target.value)}
            />
          </div>
          <div className="input-pair">
            <label className="label-name">Phone Number</label>
            <div className="phoneBox">
              <span>+92</span>
              <input
                className="simple-inp"
                type="text"
                placeholder="3001234567"
                maxLength="10"
                name="customerPhoneNo"
                style={{ borderRadius: "0 6px 6px 0" }}
                value={phoneNo}
                onChange={(e) => setPhoneNo(e.target.value)}
              />
            </div>
          </div>
          <div className="input-pair">
            <label className="label-name">Email ID</label>
            {/* If editProfile is true, then email should eb disabled */}
            <input
              autoComplete="off"
              className="simple-inp"
              placeholder="john@gmail.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={editProfile}
            />
          </div>
          <div className="input-pair">
            <label className="label-name">Password</label>
            <div className="passwordInput">
              <input
                className="simple-inp"
                autoComplete="off"
                type={showPassword ? "text" : "password"}
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <i
                className={
                  showPassword ? "bi bi-eye-fill" : "bi bi-eye-slash-fill"
                }
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="addProfileModelFooter">
          <Button
            className="button"
            variant="secondary"
            onClick={() => {
              setAddProfile(false);
              setEditProfile(false);
            }}
          >
            Close
          </Button>
          <Button 
          // onClick={createProfile}
           className="button" variant="primary">
            {addProfile ? "Add Profile" : "Save Changes"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={deleteProfile}
        onHide={() => {
          setDeleteProfile(false);
        }}
        backdrop="static"
        keyboard={false}
        centered
        className="addProfileModal"
      >
        <Modal.Header closeButton>
          <Modal.Title className="title">Delete Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="deleteProfile">
            Are you sure you want to delete this profile?
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{ justifyContent: "end", gap: "8px" }}
          className="addProfileModelFooter"
        >
          <Button
            className="delButton"
            variant="secondary"
            onClick={() => {
              setDeleteProfile(false);
            }}
          >
            No
          </Button>
          <Button
            // onClick={deleteDesigner}
            className="delButton"
            variant="primary"
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
